export default __webpack_public_path__ + "static/media/27t.1109fce3.jpg";